import React from 'react';
import './suspenseLoader.css';

import Spinner from '../spinner';

const SuspenseLoader = () => {
  return (
    <div className="et-n-suspense-loading-spinner-wrap">
      <Spinner />
    </div>
  );
};

export default SuspenseLoader;
